export default __webpack_public_path__ + "static/media/header-back.de257d5e.jpg";